var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCircleXmark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "circle-xmark",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "circle-xmark-2",
    "data-name": "circle-xmark",
    d: "M9,1.125A7.875,7.875,0,1,1,1.125,9,7.875,7.875,0,0,1,9,1.125ZM9,18A9,9,0,1,0,0,9,9,9,0,0,0,9,18ZM6.353,6.353a.564.564,0,0,0,0,.795L8.205,9,6.353,10.853a.562.562,0,0,0,.795.795L9,9.795l1.853,1.853a.562.562,0,0,0,.795-.795L9.795,9l1.853-1.853a.562.562,0,0,0-.795-.795L9,8.205,7.147,6.353A.564.564,0,0,0,6.353,6.353Z",
    fill: "#4d4d4d"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCircleXmark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/circle-xmark.eeabce85a38e99735b060b73e8ca22b6.svg";